module.exports = __webpack_public_path__ + "img/logo-small-header-mobile.9ad27ef3.svg";